<h1 matDialogTitle style="min-width: 300px;max-width: calc(60vw);">{{ title }}</h1>
<div mat-dialog-content>{{ message }}</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">{{ confirm ? translations.deleteConfirmDialogConfirm : translations.deleteConfirmDialogOkay }}</button>
    <button mat-button (click)="dialogRef.close(false)" *ngIf="confirm">{{translations.deleteConfirmDialogCancel}}</button>
</div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/core/components/confirm-dialog/confirm-dialog.component.html